import { useMemo, useState } from 'react'
import { calcDogfight } from './ggDogfight.js'
import { samplePlayers, samplePars, sampleStrokeIndex } from './ggSamplePlayers.js'

// G-Dogfight — isolated sandbox. Net vs par points (eagle+ 4 / birdie 3 / par 2
// / bogey 1 / worse 0) over/under a per-player quota. calcDogfight uses the
// exact dogfightPointsFor formula ported from GolfGamesScorecard.
const cell = { border: '1px solid #ddd', padding: '6px 10px', fontSize: 16 }

export default function GDogfight() {
  const [quota, setQuota] = useState(36)
  const [dpp, setDpp] = useState(1)
  const rows = useMemo(
    () => calcDogfight(samplePlayers(), samplePars(), sampleStrokeIndex(), { handicapsOn: true, quota: Number(quota) || 0, dollarsPerPoint: Number(dpp) || 0 }),
    [quota, dpp],
  )

  return (
    <div className="card">
      <div className="flex items-center gap-4 mb-3 text-sm text-gray-600">
        <span className="font-semibold">Quota <input type="number" className="w-14 border rounded px-1 py-0.5 ml-1" value={quota} onChange={(e) => setQuota(e.target.value)} /></span>
        <span className="font-semibold">$/point <input type="number" className="w-14 border rounded px-1 py-0.5 ml-1" value={dpp} onChange={(e) => setDpp(e.target.value)} /></span>
        <span className="text-gray-500">Net points vs par. In GGS, quotas are set per player.</span>
      </div>
      <table className="w-full text-base" style={{ borderCollapse: 'collapse' }}>
        <thead><tr style={{ background: '#f6f6f2', color: '#555' }}>{['Pos', 'Player', 'Points', 'Quota', '+/−', '$'].map((h) => <th key={h} style={{ ...cell, textAlign: 'left' }}>{h}</th>)}</tr></thead>
        <tbody>{rows.map((p, i) => (
          <tr key={p.id}>
            <td style={cell}>{i + 1}</td><td style={cell}>{p.name}</td>
            <td style={cell}>{p.total}</td><td style={cell}>{p.quota}</td>
            <td style={cell}><b style={{ color: p.vsQuota > 0 ? '#1B7A3E' : p.vsQuota < 0 ? '#B42318' : '#374151' }}>{p.vsQuota > 0 ? `+${p.vsQuota}` : p.vsQuota}</b></td>
            <td style={cell}>{p.dollars >= 0 ? `+$${p.dollars}` : `−$${Math.abs(p.dollars)}`}</td>
          </tr>
        ))}</tbody>
      </table>
    </div>
  )
}
